

export default {
    totalLeaseOrders: [],
    leaseOrders: [],
  
}
